// @flow
import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import { IoMdTrash } from 'react-icons/io';
import { MdEdit } from 'react-icons/md';
import EditingItem from './EditingItem';
import './CategoryEditItem.scss';

type Props = {
  edit?: boolean,
  key: string,
  name: string,
  temp?: boolean,
  order: number,
  parent: string,
  onToggleEditCategory(): void,
  onChange(e: SyntheticInputEvent<HTMLInputElement>): any,
  onHide(): void,
  onSelect(): void,
};

const defaultProps = {
  edit: false,
  temp: false,
  name: '',
  order: 2,
  parent: '',
};

const DefaultItem = ({ name, onHide, onSelect, onToggleEditCategory }: Props) => {
  return (
    <Fragment>
      <div className="text" onClick={onSelect}>
        {name}
      </div>
      <div className="buttons">
        <div className="button edit" onClick={onToggleEditCategory}>
          <MdEdit />
        </div>
        <div className="button remove" onClick={onHide}>
          <IoMdTrash />
        </div>
      </div>
    </Fragment>
  );
};

DefaultItem.defaultProps = defaultProps;

class CategoryEditItem extends Component<Props> {
  static defaultProps = defaultProps;

  render() {
    const { edit, name } = this.props;
    return (
      <div className={cx('CategoryEditItem', { edit })}>
        {edit ? <EditingItem {...this.props} /> : <DefaultItem {...this.props} />}
      </div>
    );
  }
}

export default CategoryEditItem;



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditItem/CategoryEditItem.js